<template>
  <div class="aidj">
    <div class="banners">
      <div class="banner-title">
        <div class="t1">AI党建</div>
        <div class="t2">国内智慧党建云平台行业引领者</div>
      </div>
    </div>
    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">建设意义</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <div style="margin-top: 24px;">
          推进党建智慧化是信息社会背景下党建工作创新发展的必然选择，是拓展党的社会活动空间的重要渠道，是提高党建工作科学化水平的必由之路。智慧党建系统的探索和实践不仅具有重要的理论价值，而且具有十分重要的实践意义。
        </div>
        <div class="flexs">
          <div class="card-1" v-for="(item, index) in yyList" :key="index">
            <div class="yuan">{{ index + 1 }}</div>
            <div class="title">{{ item.t }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">功能架构</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <div class="content-1-2" style="margin: 0 80px ;">
          <img style="width: 100%;" src="../assets/img/aidj/t1.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Banner from "../components/Banner";
export default {
  metaInfo: {
    title: "中启联信_数据资产入表",

    meta: [
      { name: "keywords", content: "中启联信、数据资产、数据资产入表" },
      { name: "description", content: "中启联信、数据资产、数据资产入表" },
    ],
  },
  data() {
    return {
      yyList: [
        { t: "数据助推党组织科学管理，实现科学化管理" },
        { t: "党务工作从线下到线上，实现高效化管理" },
        { t: "党员学习方式线上线下多样化，实现多样化教育" },
        { t: "宣传工作展示更全面，渠道更多样，实现新媒体宣传" },
        { t: "打造党员线上党建圈，加强凝聚力，实现党员凝聚力" },
        { t: "实现党组织无纸化办公，实现互联网化办公" },
        { t: "党建考核落实从严治党，实现数据化党建" },
      ],
      hoverIndex: 0,
      tabPosition: "left",
      activeName: "first",
      sjList: [
        {
          title: "数据治理",
          content:
            "确定数据标准;\n数据清洗;\n数据管理能力评估;\n数据资源目录梳理;\n……",
        },
        {
          title: "数据确权",
          content:
            "了解数据登记情况;\n界定数据来源、持有加工、流通、使用过程中的合法权利;\n明确权利或权利组合;\n获取相关权证材料;\n……",
        },
        {
          title: "数据入表专业咨询",
          content:
            "数据资产确认条件;\n基于场景的预期收益合理性判断;\n资产分类的合理性和确定依据分析;\n后续计量的价值影响分析;\n……",
        },
        {
          title: "数据资产质量评价",
          content:
            "明确数据质量评价对象及范围;\n建立质量要素评价指标体系;\n执行数据质量评价程序;\n撰写数据质量评价报告;\n……",
        },
        {
          title: "数据资产价值评估",
          content:
            "明确评估对象和范围明确应用场景和资产类型;\n数据资产评估方法适用性分析;\n数据资产价值评估;\n出具价值评估报告;\n……",
        },
      ],
      itemList: [
        {
          bg: require(`@/assets/img/advantage-0.png`),
          title: "上千次项目打磨",
        },
        {
          bg: require(`@/assets/img/advantage-1.png`),
          title: "100%项目交付质量",
        },
        {
          bg: require(`@/assets/img/advantage-2.png`),
          title: "量身打造定制化方案",
        },
        { bg: require(`@/assets/img/advantage-3.png`), title: "50+技术软著" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.aidj {
  width: 100%;
  outline: none;
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-1 {
      &:hover {
        background: #fff;
        box-shadow: 4px 6px 20px 0 rgba(0, 0, 0, 0.06);
        border: 1px solid #dce2ef;
      }
      margin-top: 24px;
      flex-shrink: 0;
      width: 160px;
      height: 140px;
      background: transparent;
      border-radius: 4px;
      border: 1px solid #dce2ef;
      text-align: center;
      padding: 16px;
      .yuan {
        border-radius: 50%;
        text-align: center;
        width: 40px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto 12px;
        color: #fff;
        font-size: 24px;
        font-weight: 700;
        background-color: rgb(231, 20, 20);
      }

      .title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1e2738;
        line-height: 1.5;
      }
    }
  }
  .content-3 {
    margin-top: 80px;
    .content-3-1 {
      text-align: center;
    }
    .content-3-2 {
      width: 1400px;
      margin: 68px auto;
      display: flex;
      justify-content: space-between;
      .box1 {
        width: 288px;
        height: 274px;
        background: #3a4354;
        border-radius: 6px;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .box1-1 {
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 45px;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          line-height: 24px;
        }
        .box1-2 {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
          color: #fff;
          text-align: center;
          opacity: 0;
          -webkit-animation: advantageHide 1s;
          animation: advantageHide 1s;
          @keyframes advantageHide {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .content-2 {
    background: #f9fbff;
    width: 100%;
    padding-top: 60px;
    min-width: 1200px;
    .content-2-3 {
      // width: 1200px;
      margin: 20px auto;
      ::v-deep .el-tabs__nav-scroll {
        width: 10%;
        margin: 0 auto;
      }
      .content-2-3-1 {
        width: 100%;
        min-width: 1200px;
        height: 23.43vw;
        background: #2b3953;
        position: relative;
        margin-top: 4.9vw;
        .text1 {
          text-align: left;
          color: #fff;
          width: 62.5vw;
          margin: 0 auto;
          padding-top: 5.28vw;
        }
        .img1 {
          opacity: 1;
          width: 50vw;
          height: 26.84vw;
          position: absolute;
          right: 0;
          bottom: 0;
          transition: all 0.5s ease-in 0.5s;
          animation: fadeIn 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
        .img2 {
          width: 30.15vw;
          height: 15.98vw;
          position: absolute;
          right: 30.57vw;
          bottom: 0;
          animation: slide-in-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            forwards;
          @keyframes slide-in-bottom {
            0% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
    .content-2-1 {
      text-align: center;
    }
    .content-2-2 {
      margin: 32px auto;
      text-align: center;
      .tabs {
        margin: 0 auto;

        ::v-deep .el-radio-button__inner {
          width: 400px;
          height: 48px;
          line-height: 24px;
          font-size: 20px;
        }
      }
    }
  }
  .content-1 {
    background: #fff;
    width: 100%;
    min-width: 1400px;
    .content-1-1 {
      text-align: center;
      .title-top {
        display: flex;
        justify-content: center;
        align-items: center;
        .title1 {
          font-size: 36px;
          margin: 0px 20px;
        }
      }
      // &:active {
      //   background: linear-gradient(135deg, #526aff, #7caefb) !important;
      //   color: #fff;
      // }
    }
  }
  .content-1 {
    width: 1400px;
    min-width: 1400px;
    margin: 130px auto;
    .content-1-1 {
      text-align: center;
      .jb-lists {
        display: flex;
        margin: 30px auto;
        width: 1400px;
        .list-item {
          height: 200px;
          .bg1 {
            background: linear-gradient(
              0deg,
              rgba(124, 174, 251, 0.2) 0%,
              rgb(82, 106, 255) 100%
            );
          }
          .bg2 {
            background: linear-gradient(
              0deg,
              rgba(120, 82, 255, 0.2) 0%,
              rgb(120, 82, 255) 100%
            );
          }
          .bg3 {
            background: linear-gradient(
              0deg,
              rgba(64, 237, 172, 0.2) 29%,
              rgb(64, 237, 172) 100%
            );
          }
          .bg4 {
            background: linear-gradient(
              180deg,
              rgba(82, 184, 255, 0.6) 29%,
              rgb(255, 255, 255) 100%
            );
          }
          .bg5 {
            background: linear-gradient(
              0deg,
              rgba(252, 255, 82, 0.2) 0%,
              rgb(235, 146, 13) 100%
            );
          }
          .items {
            width: 164px;
            height: 100%;
            padding: 28px 18px 41px 8px;
            border-radius: 10px;
            .t11 {
              color: #fff;
              font-size: 36px;
            }
            .t12 {
              margin-top: 40px;
              color: #fff;
              font-size: 18px;
              line-height: 40px;
            }
          }
          height: 434px;
          margin-right: 20px;
          background-position-x: -350px;
          background-repeat: no-repeat;
          transition: width 0.5s;
          border-radius: 10px;
          overflow: hidden;
        }
        .activeHover {
          background-position-x: 0px;
          width: 600px !important;
          box-shadow: rgba(0, 0, 0, 0.2) 0px 0px;
        }
      }
    }
    .content-1-2 {
      display: flex;
      margin-top: 30px;
      .home-app-left {
        width: 250px;
        height: 467px;
        background: linear-gradient(296deg, #7caefb, #526aff);
        box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
        border-radius: 6px 0 0 6px;
        .t1 {
          font-size: 20px;
          color: #fff;
          line-height: 60px;
          margin: 20px 0;
        }
      }
      .home-app-center {
        width: 900px;
        height: 247px;
        background-image: url(https://databaker-gw-static.oss-accelerate.aliyuncs.com/assets/images/newHome/app-bg.png);
        background-size: 100% 100%;
        box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
        border-radius: 0 6px 6px 0;
        position: relative;
        text-align: center;
        font-size: 40px;
        padding-top: 220px;
      }
      .home-app-right {
        width: 250px;
        height: 467px;
        background: linear-gradient(296deg, #7caefb, #526aff);
        box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
        border-radius: 6px 0 0 6px;
      }
    }
  }
  .home-achieve {
    position: relative;
    width: 1400px;
    margin: -60px auto;
    display: flex;
    z-index: 3;
    justify-content: space-between;
    .cards {
      transform: translateY(0px);
      opacity: 1;
      animation-delay: 200ms;
      width: 388px;
      height: 112px;
      background: #fff;
      box-shadow: 2px 6px 10px 0 rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      display: flex;
    }
  }
  .banners {
    width: 100%;
    height: 400px;
    position: relative;
    background-image: url(../assets/img/aidj/banner.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .banner-title {
      position: absolute;
      z-index: 3;
      width: 1400px;
      min-width: 1400px;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      .t1 {
        font-size: 2.2vw;
        font-family: Alibaba-PuHuiTi-Bold;
        color: #fff;
        font-weight: bold;
      }
      .t2 {
        font-size: 1.2vw;
        width: 567px;
        font-weight: 400;
        color: #fff;
        line-height: 40px;
        margin-top: 23px;
        font-family: Alibaba-PuHuiTi-Regular;
      }
    }
    video {
      height: 100%;
      width: 100%;
      position: absolute;
      right: 0px;
      top: 0px;
      // bottom: 0px;
      z-index: -1;
    }
  }
}
</style>
